import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { ChevronExpand } from "react-bootstrap-icons";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectMeasurementType } from "../../../../store/slices/settingsSlice";

function EstimationOfGroutToGroutBondResistance() {
  const { t } = useTranslation("translation");

  const [showResults, setShowResults] = useState(true);
  const onClick = () => setShowResults(!showResults);
  const metric = useSelector(selectMeasurementType);
  let isMetric = metric === 0;
  return (
    <div className="col-8" style={{ paddingTop: "10px" }}>
      <Card bg={"light"} key={1} text={"dark"} style={{ width: "100%" }} className="mb-2">
        <Card.Header onClick={onClick}>
          {t("aashto.ausser.Information")}
          <button type="button" className="float-end" style={{ border: "none" }}>
            {showResults ? t("hideDetails") : t("showDetails")}
            <ChevronExpand style={{ marginLeft: "10px" }} />
          </button>
        </Card.Header>

        {showResults && (
          <Card.Body>
            <p>
              R<sub>s</sub> = &pi; d<sub>b</sub>&alpha;<sub>d</sub>L<sub>b</sub>
            </p>
            <br />
            <dl style={{ color: "#3f3f40", fontSize: "12px" }}>
              <dt>
                R<sub>s</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.ausser.Nominal grout-to-ground bond resistance"
                  values={{
                    unit: isMetric ? "kN" : "kip",
                  }}
                />
              </dd>
              <dt>
                d<sub>b</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.ausser.Diamter of micropile drill hole through bonded length"
                  values={{
                    unit: isMetric ? "m" : "ft",
                  }}
                />
              </dd>
              <dt>
                &alpha;<sub>b</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.ausser.Nominal micropile grout-to-ground bond strength"
                  values={{
                    unit: isMetric ? "kN/m²" : "ksf",
                  }}
                />
              </dd>
              <dt>
                L<sub>b</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.ausser.Micropile bonded length"
                  values={{
                    unit: isMetric ? "m" : "ft",
                  }}
                />
              </dd>
            </dl>
          </Card.Body>
        )}
      </Card>
    </div>
  );
}

export default EstimationOfGroutToGroutBondResistance;
